exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".calculator-tabs[data-v-01fcab10]{color:#072942!important}.calculator-tabs[data-v-01fcab10] .calculator__tab{border-radius:10px 10px 0 0;font-size:14px}.calculator-tabs[data-v-01fcab10] .calculator__tab.active{background:#fff}.calculator-tabs[data-v-01fcab10] .calculator__tab:not(.active){font-weight:400}", ""]);

